
// Until Vuetify measures the viewport (after hydration), the flags hold the width the
// server guessed from the User-Agent; how a first render may use them is set out in
// plugins/vuetify-ssr-display.ts.
export const useBreakpoints = () => {
    const breakpoints = useDisplay()
    const isMobile = computed(() => {
      return breakpoints.mobile.value
    })
    return { breakpoints, isMobile}
}
